import create from './createAction'

export const GET_PUBLIC_CERT = 'GET_PUBLIC_CERT'
export const SET_PUBLIC_CERT = 'SET_PUBLIC_CERT'
export const SIGN_IN = 'SIGN_IN'
export const CHECK_AUTH = 'CHECK_AUTH'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const SET_LOGIN_MSG = 'SET_LOGIN_MSG'
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR'
export const SET_USER = 'SET_USER'
export const SIGN_OUT = 'SIGN_OUT'
export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL'
export const SIGN_UP = 'SIGN_UP'
export const SET_SIGNUP_MSG = 'SET_SIGNUP_MSG'
export const SET_SIGNUP_SUCCESS = 'SET_SIGNUP_SUCCESS'
export const SET_SIGNUP_ERROR = 'SET_SIGNUP_ERROR'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_GUEST = 'SIGN_UP_GUEST'
export const SET_SIGNUP_GUEST_MSG = 'SET_SIGNUP_GUEST_MSG'
export const SIGN_UP_GUEST_SUCCESS = 'SIGN_UP_GUEST_SUCCESS'
export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const EMAIL_IS_VERIFIED = 'EMAIL_IS_VERIFIED'
export const EMAIL_VERIFICATION_ERROR = 'EMAIL_VERIFICATION_ERROR'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const SET_RESET_PASSWORD_MSG = 'SET_RESET_PASSWORD_MSG'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const SET_FORGOT_PASSWORD_MSG = 'SET_FORGOT_PASSWORD_MSG'
export const SET_FORGOT_PASSWORD_SUCCESS = 'SET_FORGOT_PASSWORD_SUCCESS'
export const SET_FORGOT_PASSWORD_ERROR = 'SET_FORGOT_PASSWORD_ERROR'
export const CLEAR_USER = 'CLEAR_USER'
export const SET_IS_CHECKING_AUTH = 'SET_IS_CHECKING_AUTH'
export const getPublicCert = create(GET_PUBLIC_CERT)
export const setPublicCert = create(SET_PUBLIC_CERT)
export const signin = create(SIGN_IN)
export const checkAuth = create(CHECK_AUTH)
export const setToken = create(SET_TOKEN)
export const setAuthToken = create(SET_AUTH_TOKEN)
export const setLoginMsg = create(SET_LOGIN_MSG)
export const setLoginError = create(SET_LOGIN_ERROR)
export const setUser = create(SET_USER)
export const signout = create(SIGN_OUT)
export const resendVerificationEmail = create(RESEND_VERIFICATION_EMAIL)
export const signUp = create(SIGN_UP)
export const setSignupMsg = create(SET_SIGNUP_MSG)
export const setSignUpSuccess = create(SET_SIGNUP_SUCCESS)
export const setSignUpError = create(SET_SIGNUP_ERROR)
export const signUpSuccess = create(SIGN_UP_SUCCESS)
export const signUpGuest = create(SIGN_UP_GUEST)
export const setSignupGuestMsg = create(SET_SIGNUP_GUEST_MSG)
export const signUpGuestSuccess = create(SIGN_UP_GUEST_SUCCESS)
export const verifyEmail = create(VERIFY_EMAIL)
export const emailIsVerified = create(EMAIL_IS_VERIFIED)
export const emailVerificationError = create(EMAIL_VERIFICATION_ERROR)
export const forgotPassword = create(FORGOT_PASSWORD)
export const setForgotPasswordMsg = create(SET_FORGOT_PASSWORD_MSG)
export const setForgotPasswordSuccess = create(SET_FORGOT_PASSWORD_SUCCESS)
export const setForgotPasswordError = create(SET_FORGOT_PASSWORD_ERROR)
export const resetPassword = create(RESET_PASSWORD)
export const setResetPasswordMsg = create(SET_RESET_PASSWORD_MSG)
export const clearUser = create(CLEAR_USER)
export const setIsCheckingAuth = create(SET_IS_CHECKING_AUTH)
